import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '../../pipes/pipes.module';
import { ProcessConfigurationModule } from '../process-configuration/process-configuration.module';
import { ConsentGoalsComponent } from './consent-goals.component';
import { NewGoalsInputModule } from 'src/app/shared/modals/new-goals-input/new-goals-input.module';

@NgModule({
    declarations: [
        ConsentGoalsComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        PipesModule,
        ProcessConfigurationModule,
        NewGoalsInputModule
    ],
    exports: [ConsentGoalsComponent]
})
export class ConsentGoalsModule {
}
